import { render, staticRenderFns } from "./PublicRoot.vue?vue&type=template&id=37819008&scoped=true"
import script from "./PublicRoot.vue?vue&type=script&lang=ts"
export * from "./PublicRoot.vue?vue&type=script&lang=ts"
import style0 from "./PublicRoot.vue?vue&type=style&index=0&id=37819008&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37819008",
  null
  
)

export default component.exports